// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__e3I4E","arrowDisabled":"styles_arrowDisabled__8NgVq"};